import React, { useContext } from "react";
import "./Plan_Information_Component.css";
import { Accordion, Table } from "react-bootstrap";
import {
  faCircleCheck,
  faCircleQuestion,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Context } from "../../../utils/context";

const Plan_Information_Component = ({ selectedPlansdata }) => {
  const { IMG_URL } = useContext(Context);
  return (
    <section className="Plan_Information_Component">
      <div className="about_us_section accordion_main_div">
        <Accordion defaultActiveKey="0" flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <div className="question_div">
                <p className="question">About Us</p>
              </div>

              <div className="icon_holder minus_icon">
                <FontAwesomeIcon icon={faSortUp} className="icon" />
              </div>
              <div className="icon_holder plus_icon">
                <FontAwesomeIcon icon={faSortDown} className="icon" />
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <div className="card_holder">
                <div className="table-responsive">
                  <Table responsive>
                    <thead className="">
                      <tr>
                        <th></th>
                        {selectedPlansdata?.map((val) => (
                          <th className="">
                            <div className="img_holder">
                              <img src={IMG_URL + val?.image} className="img" />
                            </div>
                          </th>
                        ))}
                        {/* <th className="">
                          <div className="img_holder">
                            <img
                              src="\assets\Image\aboutus\partner\img4.png"
                              className="img"
                            />
                          </div>
                        </th> */}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <p className="title_text">Premium From 2nd Year</p>
                        </td>
                        {selectedPlansdata?.map((val) => (
                          <td>
                            <p className="price_text">
                              <span className="blue_text">
                                ₹{" "}
                                {Number(
                                  val?.f_i_amounts?.find(
                                    (a) => a?.f_insurance_type?.id === 2
                                  )?.online_amount
                                ).toLocaleString("en-IN", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }) || "N/A"}
                              </span>{" "}
                              monthly
                            </p>
                          </td>
                        ))}
                        {/* <td>
                          <p className="td_text_right">₹ 954 monthly</p>
                        </td> */}
                      </tr>

                      <tr>
                        <td>
                          <p className="title_text">Max. Coverage Upto</p>
                        </td>
                        {/* <td>
                          <div className="dashed_blue_div">
                            <div className="icon_holder">
                              <FontAwesomeIcon
                                icon={faCircleCheck}
                                className="icon"
                              />
                            </div>
                            <p className="title_text">85 Years</p>
                          </div>
                        </td> */}
                        {selectedPlansdata?.map((val) => (
                          <td>
                            <p className="simple_text">
                              {val?.cover_till_age} Years
                            </p>
                          </td>
                        ))}
                      </tr>

                      <tr>
                        <td>
                          <div className="text_with_icon_div">
                            <div className="text_holder">
                              <p className="text">Claim Settlement Ratio</p>
                            </div>
                            <div className="icon_holder">
                              <FontAwesomeIcon
                                icon={faCircleQuestion}
                                className="question_icon"
                              />
                            </div>
                          </div>
                        </td>
                        {selectedPlansdata?.map((val) => (
                          <td>
                            <div className="dashed_blue_div">
                              <div className="icon_holder">
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  className="icon"
                                />
                              </div>
                              <p className="title_text">{val?.claim_settled}</p>
                            </div>
                          </td>
                        ))}
                        {/* <td>
                          <p className="simple_text">70 Years</p>
                        </td> */}
                      </tr>

                      <tr>
                        <td>
                          <div className="text_with_icon_div">
                            <div className="text_holder">
                              <p className="text">Life Cover</p>
                            </div>
                            <div className="icon_holder">
                              <FontAwesomeIcon
                                icon={faCircleQuestion}
                                className="question_icon"
                              />
                            </div>
                          </div>
                        </td>
                        {/* <td>
                          <p className="price_text">₹ 830 monthly</p>
                          <p className="light_subtext">discount included</p>
                          <p className="link_text">Show how</p>
                        </td> */}
                        {selectedPlansdata?.map((val) => (
                          <td>
                            <p className="simple_text">{val?.life_cover} </p>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </Table>

                  {/* <div className="table_wrapper">
                    <div className="table_scroll_container">
                      <Table responsive className="custom_table">
                        <thead>
                          <tr>
                            <th className="sticky-col first-col"></th>
                            {selectedPlansdata?.map((val) => (
                              <th>
                                <div className="img_holder">
                                  <img
                                    src={IMG_URL + val?.image}
                                    className="img"
                                  />
                                </div>
                              </th>
                            ))}
                          
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="sticky-col first-col">
                              <p className="title_text">
                                Premium From 2nd Year
                              </p>
                            </td>
                            {selectedPlansdata?.map((val) => (
                              <td>
                                <p className="price_text">
                                  <span className="blue_text">
                                    {" "}
                                    {Number(
                                      val?.f_i_amounts?.find(
                                        (a) => a?.f_insurance_type?.id === 2
                                      )?.online_amount
                                    ).toLocaleString("en-IN", {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 0,
                                    }) || "N/A"}
                                  </span>{" "}
                                  monthly
                                </p>
                              </td>
                            ))}
                          
                          </tr>

                          <tr>
                            <td className="sticky-col first-col">
                              <p className="title_text">Max. Coverage Upto</p>
                            </td>
                            <td>
                              <div className="dashed_blue_div">
                                <div className="icon_holder">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    className="icon"
                                  />
                                </div>
                                <p className="title_text">85 Years</p>
                              </div>
                            </td>
                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>
                          </tr>

                          <tr>
                            <td className="sticky-col first-col">
                              <div className="text_with_icon_div">
                                <div className="text_holder">
                                  <p className="text">Claim Settlement Ratio</p>
                                </div>
                                <div className="icon_holder">
                                  <FontAwesomeIcon
                                    icon={faCircleQuestion}
                                    className="question_icon"
                                  />
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="dashed_blue_div">
                                <div className="icon_holder">
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    className="icon"
                                  />
                                </div>
                                <p className="title_text">85 Years</p>
                              </div>
                            </td>
                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>
                          </tr>

                          <tr>
                            <td className="sticky-col first-col">
                              <div className="text_with_icon_div">
                                <div className="text_holder">
                                  <p className="text">Claim Settlement Ratio</p>
                                </div>
                                <div className="icon_holder">
                                  <FontAwesomeIcon
                                    icon={faCircleQuestion}
                                    className="question_icon"
                                  />
                                </div>
                              </div>
                            </td>
                            <td>
                              <p className="price_text">₹ 830 monthly</p>
                              <p className="light_subtext">discount included</p>
                              <p className="link_text">Show how</p>
                            </td>
                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>

                            <td>
                              <p className="simple_text">70 Years</p>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div> */}
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      <div className="plan_feature_section accordion_main_div">
        <Accordion defaultActiveKey="0" flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <div className="question_div">
                <p className="question">About Insurer</p>
              </div>

              <div className="icon_holder minus_icon">
                <FontAwesomeIcon icon={faSortUp} className="icon" />
              </div>
              <div className="icon_holder plus_icon">
                <FontAwesomeIcon icon={faSortDown} className="icon" />
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <div className="card_holder">
                <div className="table-responsive">
                  <Table responsive>
                    <tbody>
                      <tr>
                        <td>
                          <p className="title_text">About Plane</p>
                        </td>
                        {selectedPlansdata?.map((val) => (
                          <td>
                            <p className="td_text_right">{val?.about_plane}</p>
                          </td>
                        ))}
                      </tr>

                      <tr>
                        <td>
                          <p className="title_text">What Cover</p>
                        </td>
                        {/* <td>
                          <div className="dashed_blue_div">
                            <div className="icon_holder">
                              <FontAwesomeIcon
                                icon={faCircleCheck}
                                className="icon"
                              />
                            </div>
                            <p className="title_text">85 Years</p>
                          </div>
                        </td> */}
                        {selectedPlansdata?.map((val) => (
                          <td>
                            <p className="simple_text">{val?.what_cover}</p>
                          </td>
                        ))}
                      </tr>

                      <tr>
                        <td>
                          <div className="text_with_icon_div">
                            <div className="text_holder">
                              <p className="text">What Not Cover</p>
                            </div>
                            <div className="icon_holder">
                              <FontAwesomeIcon
                                icon={faCircleQuestion}
                                className="question_icon"
                              />
                            </div>
                          </div>
                        </td>
                        {/* <td>
                          <div className="dashed_blue_div">
                            <div className="icon_holder">
                              <FontAwesomeIcon
                                icon={faCircleCheck}
                                className="icon"
                              />
                            </div>
                            <p className="title_text">85 Years</p>
                          </div>
                        </td> */}
                        {selectedPlansdata?.map((val) => (
                          <td>
                            <p className="simple_text">{val?.what_not_cover}</p>
                          </td>
                        ))}
                      </tr>

                      {/* <tr>
                        <td>
                          <div className="text_with_icon_div">
                            <div className="text_holder">
                              <p className="text">Claim Settlement Ratio</p>
                            </div>
                            <div className="icon_holder">
                              <FontAwesomeIcon
                                icon={faCircleQuestion}
                                className="question_icon"
                              />
                            </div>
                          </div>
                        </td>
                        <td>
                          <p className="price_text">₹ 830 monthly</p>
                          <p className="light_subtext">discount included</p>
                          <p className="link_text">Show how</p>
                        </td>
                        <td>
                          <p className="simple_text">70 Years</p>
                        </td>
                      </tr> */}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      {/* <div className="plan_feature_section accordion_main_div">
        <Accordion defaultActiveKey="0" flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <div className="question_div">
                <p className="question">Plan Features</p>
              </div>

              <div className="icon_holder minus_icon">
                <FontAwesomeIcon icon={faSortUp} className="icon" />
              </div>
              <div className="icon_holder plus_icon">
                <FontAwesomeIcon icon={faSortDown} className="icon" />
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <div className="card_holder">
                <div className="table-responsive">
                  <Table responsive>
                    <tbody>
                        
                      <tr>
                        <td>
                          <p className="title_text">Premium From 2nd Year</p>
                        </td>
                        <td>
                          <div className="icon_holder">
                            <FontAwesomeIcon
                              icon={faCircleCheck}
                              className="icon"
                            />
                          </div>
                        </td>
                        <td>
                          <p className="td_text_right">₹ 954 monthly</p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <p className="title_text">Max. Coverage Upto</p>
                        </td>
                        <td>
                          <div className="dashed_blue_div">
                            <div className="icon_holder">
                              <FontAwesomeIcon
                                icon={faCircleCheck}
                                className="icon"
                              />
                            </div>
                            <p className="title_text">85 Years</p>
                          </div>
                        </td>
                        <td>
                          <p className="simple_text">70 Years</p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div className="text_with_icon_div">
                            <div className="text_holder">
                              <p className="text">Claim Settlement Ratio</p>
                            </div>
                            <div className="icon_holder">
                              <FontAwesomeIcon
                                icon={faCircleQuestion}
                                className="question_icon"
                              />
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="dashed_blue_div">
                            <div className="icon_holder">
                              <FontAwesomeIcon
                                icon={faCircleCheck}
                                className="icon"
                              />
                            </div>
                            <p className="title_text">85 Years</p>
                          </div>
                        </td>
                        <td>
                          <p className="simple_text">70 Years</p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div className="text_with_icon_div">
                            <div className="text_holder">
                              <p className="text">Claim Settlement Ratio</p>
                            </div>
                            <div className="icon_holder">
                              <FontAwesomeIcon
                                icon={faCircleQuestion}
                                className="question_icon"
                              />
                            </div>
                          </div>
                        </td>
                        <td>
                          <p className="price_text">₹ 830 monthly</p>
                          <p className="light_subtext">discount included</p>
                          <p className="link_text">Show how</p>
                        </td>
                        <td>
                          <p className="simple_text">70 Years</p>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div> */}
    </section>
  );
};

export default Plan_Information_Component;
